"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AzureStatus = void 0;
var _ApplicationContext = require("../ApplicationContext");
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const getSessionStorage = () => {
  try {
    return window.opener && window.opener.document && window.opener.document.domain === window.document.domain ? window.opener.sessionStorage : sessionStorage;
    // eslint-disable-next-line no-empty
  } catch {}
  return sessionStorage;
};
const appStorage = getSessionStorage();
const context_key = "azure-ad.status";
class AzureStatus {
  constructor() {
    _defineProperty(this, "state", 'NOT_STARTED');
    _defineProperty(this, "message", null);
    _defineProperty(this, "accessToken", null);
    _defineProperty(this, "idToken", null);
  }
  isNew() {
    return this.state === 'NOT_STARTED';
  }
  isInProcess() {
    return this.state === 'IN_PROCESS';
  }
  isAuthenticationReady() {
    return this.state === 'AUTH_READY';
  }
  isErrant() {
    return this.state === 'ERROR';
  }
  isComplete() {
    return this.state == 'COMPLETE';
  }
  setInProcess() {
    this.message = null;
    this.accessToken = null;
    this.identityToken = null;
    this.state = 'IN_PROCESS';
    update(this);
  }
  setAuthReady(accessToken, identityToken) {
    this.state = 'AUTH_READY';
    this.message = null;
    this.accessToken = accessToken;
    this.identityToken = identityToken;
    update(this);
  }
  setComplete() {
    this.state = "COMPLETE";
    this.message = null;
    update(this);
  }
  setErrant(message) {
    this.state = "ERROR";
    this.message = message;
    update(this);
  }
  getMessage() {
    return this.message;
  }
  getAccessToken() {
    return this.accessToken;
  }
  getIdentityToken() {
    return this.identityToken;
  }
  static reset() {
    const azureStatus = new AzureStatus();
    update(azureStatus);
  }
  static get() {
    var json = appStorage.getItem(context_key);
    var azureStatus = new AzureStatus();
    if (typeof json === 'string') {
      azureStatus = Object.assign(new AzureStatus(), JSON.parse(json));
    }
    return azureStatus;
  }
}
exports.AzureStatus = AzureStatus;
const update = azureStatus => {
  appStorage.removeItem(context_key);
  appStorage.setItem(context_key, JSON.stringify(azureStatus));
};
//# sourceMappingURL=AzureStatus.js.map